const $ = jQuery.noConflict();

const forms = {
    wrapper: $('.gform_wrapper'),
    select() {
        // Apply select2 plugin to gform select fields
        const selectFields = this.wrapper.find('select:not([class*=select2])');

        if (selectFields.length) {
            selectFields.each((j, select) => {
                const selectSingle = $(select);
                const placeholder = selectSingle.children('.gf_placeholder');

                if ( selectSingle.attr('multiple') ) {
                    selectSingle.select2MultiCheckboxes({
                        placeholder: "Select Option",
                        templateSelection: function(selected, total) {
                            return `Select Option (${selected.length})`;
                        }
                    });
                } else {
                    selectSingle.select2({
                        minimumResultsForSearch: 999,
                        placeholder: placeholder.length ? placeholder.text() : 'Select an option',
                        width: '100%',
                    });
                }
            });
        }
    },
};

export default forms;
